export default __webpack_public_path__ + "static/media/vizion.1a3616f3.png";